import React from 'react';
import { useNavigate } from 'react-router-dom';
import Login from './Login';
import './Login.css';
import './App.css';

export default function LoginPageWrapper() {
  const navigate = useNavigate();

  const handleLogin = (data) => {
    // Store user data and redirect to main app
    localStorage.setItem('user', JSON.stringify(data));
    navigate('/');
    window.location.reload(); // Refresh to load logged-in state in App
  };

  const handleRegister = () => {
    navigate('/register');
  };

  return (
    <div className="centered-page">
      <div className="title">
        <span className="title-the">The</span><span className="title-turf">Turf</span>
        <span className="title-at-gsc">at GSC</span>
        <span className="title-scheduler">Scheduler</span>
      </div>
      <Login onLogin={handleLogin} onRegister={handleRegister} onHome={() => navigate('/')} />
    </div>
  );
}
